// extracted by mini-css-extract-plugin
module.exports = {"audience":"audience__1yj2S","rest":"rest__1bplX"};